module.exports = __webpack_public_path__ + "static/media/eshwar_intro.d9e3ce72.jpg";